import { useState } from "react";
import { useApolloClient } from "@apollo/client";

import { useDeliveryCard } from "./useDeliveryCard";
import { OrderLine } from "../../../pages/OrderDetailsPage/OrderDetailsTypes";
import {
  GET_ACTIVE_ORDER,
  GET_TOTAL_LINES,
} from "../../../queries/cart.queries";

export function useCopyOrderToBasket() {
  const { addItemToOrder } = useDeliveryCard({ refetch: false });
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);

  // returns a consolidated result
  const copyOrder = async (lines: OrderLine[]) => {
    if (!lines?.length) return { ok: true };

    setLoading(true);

    let failedResult: any = null;

    for (const line of lines) {
      const res = await addItemToOrder(
        line.productVariant.id,
        line.quantity as number
      );

      if (!res.ok && !failedResult) {
        failedResult = res;
        // continue processing or break early depending on requirements
        // If you want to stop on first failure, uncomment:
        // break;
      }
    }

    await Promise.all([
      client.query({ query: GET_TOTAL_LINES, fetchPolicy: "network-only" }),
      client.query({ query: GET_ACTIVE_ORDER, fetchPolicy: "network-only" }),
    ]);

    setLoading(false);

    return {
      ok: failedResult === null,
      failed: failedResult,
    };
  };

  return {
    copyOrder,
    loading,
  };
}
